import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Row, Col, Spinner, Alert } from "reactstrap";
import { isFirefox } from "react-device-detect";

function Relatorios() {
  const [url, setUrl] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const linkDashBoat = sessionStorage.getItem("LINK_DASHBOARD");

    if (!linkDashBoat) {
      setError("URL do dashboard não encontrada.");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    setTimeout(() => {
      setUrl(linkDashBoat);
      setIsLoading(false);
    }, 500);
  }, []);

  return (
    <>
      <Helmet>
        <title>Relatórios | Semalo</title>
      </Helmet>
      <div className="content" style={{ minHeight: "100vh" }}>
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <Spinner color="primary" />
          </div>
        ) : error ? (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        ) : isFirefox ? (
          <Alert color="warning" style={{ margin: "20px" }}>
            <h4 className="alert-heading">Navegador não suportado</h4>
            <p>
              Este conteúdo é compatível apenas com o Google Chrome e Edge. Por
              favor, use o Chrome ou Edge para visualizar o dashboard.
            </p>
          </Alert>
        ) : url ? (
          <iframe
            src={url}
            title="Dashboard"
            style={{
              width: "100%",
              height: "100vh",
              border: "none",
            }}
            allowFullScreen
            onLoad={() => setIsLoading(false)} // Garante que o loading termine quando o iframe carregar
          />
        ) : null}
        {/* Código comentado mantido para referência */}
        {/* <Row>
          <Col md={4}>
            <CardRelatorio
              title="Clientes Inadimplentes"
              subtitle="Listagem"
              description="Apresenta os clientes com pagamentos em aberto até data atual."
              redirect="relatorios/clientes-inadimplentes"
            />
          </Col>
          <Col md={4}>
            <CardRelatorio
              title="Comissões Provisionadas"
              subtitle="Listagem"
              description="Apresenta o provisionamento das comissões."
              redirect="relatorios/comissoes-provisionadas"
            />
          </Col>
        </Row> */}
      </div>
    </>
  );
}

export default Relatorios;
